/**
 * Pure eligibility contract for label re-anchoring after a Leaflet map settles.
 * It deliberately contains no map or persistence access: callers own the
 * session/generation counters and pass only a cloned drawing snapshot to Leaflet.
 */
export interface DrawLabelReanchorRequest {
  requestGeneration: number;
  currentGeneration: number;
  isDrawing: boolean;
  hasActiveMidpointDrag: boolean;
  areSegmentLabelsVisible: boolean;
  vertexCount: number;
}

export function shouldRunDrawLabelReanchor(request: DrawLabelReanchorRequest): boolean {
  return request.requestGeneration === request.currentGeneration
    && request.isDrawing
    && !request.hasActiveMidpointDrag
    && request.areSegmentLabelsVisible
    && request.vertexCount >= 2;
}
